import { Component } from '@theme/component';
import { debounce, setHeaderMenuStyle } from '@theme/utilities';

/**
 * Header menu (Detailing-Concept).
 *
 * The desktop mega-menu and the mobile drawer are handled by the custom
 * `dc-megamenu` snippet (the "MAGASINER PAR UNIVERS" glass menu, click-to-open).
 * To avoid two overlapping menus, Horizon's native header-menu no longer opens
 * any submenu: this component is intentionally inert and only keeps the
 * desktop/drawer breakpoint in sync on resize.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} overflowMenu - The overflow menu.
 * @extends {Component<Refs>}
 */
class HeaderMenu extends Component {
  requiredRefs = ['overflowMenu'];

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.#resizeListener);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.#resizeListener);
  }

  /**
   * Keep the menu/drawer style in sync when crossing the breakpoint.
   */
  #resizeListener = debounce(() => {
    setHeaderMenuStyle();
  }, 100);

  /**
   * No-op handlers kept so the template's declarative on:* bindings resolve
   * to a function without opening the native submenu.
   */
  activate() {}
  deactivate() {}
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}
